<template>   
    <div>
      <v-card flat>      
          <div>
            <v-row no-gutters fill-height>
              <v-expansion-panels
                v-model="panel"
                :disabled="disabled"
                multiple 
                accordion     
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>Select Condition
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <!-- =============Start Search Condition============= -->
                        <v-row dense class="ma-0">
                          <v-col
                            class="pl-0"
                            cols="6"
                            sm="6"
                            md="4"
                          >                           
                          <DxDateBox  
                              label="Insp.Date"                            
                              :value="stDate" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false"
                              @value-changed="e => {stDate = e.value && getStrFormat(e.value)}"
                              dense
                          />
                          </v-col>

                          <v-col                            
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="Ship No"
                                v-model="shipNo" 
                                :items="shipNoList" 
                                return-object 
                                item-value="shipNo" 
                                outlined
                                dense
                              >
                              </v-select>
                          </v-col>

                          <v-col
                            class="mt-2"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="Supplier"
                                v-model="custName" 
                                :items="makerCdList" 
                                item-value="custName" 
                                return-object 
                                outlined 
                                dense
                              >
                              </v-select>
                          </v-col>
                          <!-- QM Part -->
                          <v-col                            
                            class="mt-2"
                            cols="6"
                            sm="6"
                            md="4"
                          >
                              <v-select 
                                label="QM Part"
                                v-model="qmPartName" 
                                :items="qmPartNameList" 
                                return-object 
                                item-value="qmPartName" 
                                outlined
                                dense
                              >
                              </v-select>
                          </v-col>
                        </v-row>
                      <!-- ==========End Search Condition================= -->
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </div>
           <!-- Search Data -->
          <v-fab-transition>
            <v-btn
              v-show="!isMobileDevice" 
              @click="btnRetrieve"
              absolute
              top
              right
              fab
            >
              <v-icon color="success">mdi-magnify</v-icon>
            </v-btn>
          </v-fab-transition>
      </v-card> 
      
      <v-card class="mt-2">  
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" fab small @click="exportToExcel" class="ml-2">
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </v-card-title>  

            <v-data-table
              :mobile-breakpoint="800"              
              :items-per-page="20"
              :headers="headers"
              :items="gridMainList"
              fixed-header
              :height="isMobileDevice ? undefined : 600"
              :search="search"
              dense
              :sort-by="[]"
              :sort-desc="[false]"
              :dark="dark"
              class="mobile-clean-table"
              style="max-width: 100%; overflow-x: auto;"
            >
              <template v-slot:item="{ item, isMobile }">
    
                <v-card 
                  v-if="isMobile" 
                  class="mobile-record-card clickable-card" 
                  :class="{ 'row-active': selectedRowIndex === item.rno }"
                  outlined 
                  :dark="dark"
                  flat
                  v-ripple
                  @click="selectedRowIndex = (selectedRowIndex === item.rno ? null : item.rno)"
                >
                  <div class="mobile-header d-flex justify-space-between align-center px-3 py-2">
                    <span class="font-weight-bold white--text">No</span>
                    <v-chip dark >{{ item.rno }}</v-chip>
                  </div>

                  <div class="mobile-body">
                    <div class="m-row px-3 py-1">
                      <span class="m-label">Owner</span>
                      <span class="m-value">{{ item.ownNm }}</span>
                    </div>
                    <div class="m-row px-3 py-2 gray-bg">
                      <span class="m-label">Ship No</span>
                      <span class="m-value">{{ item.shipNo }}</span>
                    </div>
                    <div class="m-row px-3 py-2">
                      <span class="m-label">Sub con Name</span>
                      <span class="m-value">{{ item.custNm }}</span>
                    </div>
                    <div class="m-row px-3 py-2 gray-bg">
                      <span class="m-label">POR No</span>
                      <span class="m-value">{{ item.porNo }}</span>
                    </div>
                    <div class="m-row px-3 py-2">
                      <span class="m-label">Item</span>
                      <span class="m-value text-right">{{ item.itemDesc2 }}</span>
                    </div>
                    <div class="m-row px-3 py-2 gray-bg">
                      <span class="m-label">Kind of insp</span>
                      <span class="m-value">{{ item.kindNm }}</span>
                    </div>
                    <div class="m-row px-3 py-2">
                      <span class="m-label">QM part</span>
                      <span class="m-value">{{ item.qmPart }}</span>
                    </div>
                    <div class="m-row px-3 py-2 gray-bg">
                      <span class="m-label">Qty</span>
                      <span class="m-value">{{ item.porQty }}</span>
                    </div>
                    <div class="m-row px-3 py-2">
                      <span class="m-label">Result</span>
                      <span class="m-value blue--text font-weight-bold">{{ item.resNm }}</span>
                    </div>
                    <div class="m-row px-3 py-2 gray-bg">
                      <span class="m-label">Req. Date</span>
                      <span class="m-value">{{ item.reqDate }}</span>
                    </div>
                    <div class="m-row px-3 py-2">
                      <span class="m-label">Insp. Date</span>
                      <span class="m-value">{{ item.insDate }}</span>
                    </div>

                    <div class="m-row px-3 py-2 gray-bg">
                      <span class="m-label">LQC/QM attend</span>
                      <div class="m-value d-flex justify-end">
                        <v-checkbox v-model="item.wlq" label="LQC" dense hide-details disabled class="ma-0 pa-0 mr-3"></v-checkbox>
                        <v-checkbox v-model="item.wqm" label="QM" dense hide-details disabled class="ma-0 pa-0"></v-checkbox>
                      </div>
                    </div>
                    <div class="m-row px-3 py-2">
                      <span class="m-label">Witness attend</span>
                      <div class="m-value d-flex justify-end">
                        <v-checkbox v-model="item.wow" label="OW" dense hide-details disabled class="ma-0 pa-0 mr-3"></v-checkbox>
                        <v-checkbox v-model="item.wcl" label="CL" dense hide-details disabled class="ma-0 pa-0"></v-checkbox>
                      </div>
                    </div>
                    
                    <div class="m-row px-3 py-2 gray-bg border-red-bottom">
                      <span class="m-label">Maker attend</span>
                      <div class="m-value d-flex justify-end">
                        <v-checkbox v-model="item.wmk" label="MK" dense hide-details disabled class="ma-0 pa-0"></v-checkbox>
                      </div>
                    </div>
                  </div>
                </v-card>

                <tr v-else class="custom-pc-row">
                  <!-- <td class="text-center v-data-table__divider">
                    <v-chip :color="getColor(item.rno)" dark>{{ item.rno }}</v-chip>
                  </td> -->
                  <td class="v-data-table__divider">{{ item.rno }}</td>
                  <td class="v-data-table__divider">{{ item.ownNm }}</td>
                  <td class="v-data-table__divider">{{ item.shipNo }}</td>
                  <td class="v-data-table__divider">{{ item.custNm }}</td>
                  <td class="v-data-table__divider">{{ item.porNo }}</td>
                  <td class="v-data-table__divider">{{ item.itemDesc2 }}</td>
                  <td class="v-data-table__divider">{{ item.kindNm }}</td>
                  <td class="v-data-table__divider">{{ item.qmPart }}</td>
                  <td class="v-data-table__divider">{{ item.porQty }}</td>
                  <td class="v-data-table__divider">{{ item.resNm }}</td>
                  <td class="v-data-table__divider">{{ item.reqDate }}</td>
                  <td class="v-data-table__divider">{{ item.insDate }}</td>
                  <td class="v-data-table__divider">
                    <div class="d-flex">
                      <v-checkbox v-model="item.wlq" label="LQC" dense hide-details disabled class="mr-2 mt-0"></v-checkbox>
                      <v-checkbox v-model="item.wqm" label="QM" dense hide-details disabled class="mt-0"></v-checkbox>
                    </div>
                  </td>
                  <td class="v-data-table__divider">
                    <div class="d-flex">
                      <v-checkbox v-model="item.wow" label="OW" dense hide-details disabled class="mr-2 mt-0"></v-checkbox>
                      <v-checkbox v-model="item.wcl" label="CL" dense hide-details disabled class="mt-0"></v-checkbox>
                    </div>
                  </td>
                  <td >
                    <v-checkbox v-model="item.wmk" label="MK" dense hide-details disabled class="mt-0"></v-checkbox>
                  </td>
                </tr>
              </template>
            </v-data-table>               
      </v-card>

     <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    </div>  
</template>

<script>
import  {
          mdiAccount,
          mdiPencil,
          mdiShareVariant,
          mdiDelete,
          mdiSelectSearch,
          mdiMapSearch 

        } from '@mdi/js'

import  { getShipList, 
          getDeptList,
          getRespList,
          getMakerList,
          getQMPartList,
        } from '@/api/view/tqm/80/v80comm.js'

import  {
          v80b2010List,
        } from '@/api/view/tqm/80/v80b2010.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import EventBus from '@/components/event-bus';

import {
  getDateFormat,
} from '@/utils/common.js'
import * as XLSX from 'xlsx';


export default {
  name: "v80b2010",
  mixins: [baseview, BaseDataGrid],
  data: () => ({
    fab: false,
    dark: false,
    isMobileDevice: false, // Biến mới
    icons: {
      mdiAccount,
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
      mdiSelectSearch,
      mdiMapSearch

    },
    stDate: '',
    shipNoList: [],
    shipNo: '',
    makerCdList: [],
    makerCd: '',
    custName: '',

    deptName: '',
    deptNameList: [],
    deptCd: '',
    respName: '',
    respNameList: [],
    respCd: '',
    qmPart: '',
    qmPartName:'',
    qmPartNameList: [],
    panel: [0],
    disabled: false,
    hover: true,

    // data
    gridMainList: [],
    listSize: 0,
    
    mobile: false,
    search: '',
    headers: [
                {
                  text: 'No',
                  align: 'start',
                  value: 'rno',
                  divider: true,
                  sortable: false,
                  width: '20px'
                },
                { text: 'Owner', sortable: false, align: 'center',value: 'ownNm', width: '120px' },
                { text: 'Ship No', sortable: false, align: 'center',value: 'shipNo', width: '30px' },
                { text: 'Supplier', sortable: false, align: 'center',value: 'custNm', width: '200px' },
                { text: 'POR No', sortable: false, align: 'center',value: 'porNo', width: '100px' },
                { text: 'Item', sortable: true, align: 'center',value: 'itemDesc2', width: '250px' },
                { text: 'Kind of insp', sortable: false, align: 'center',value: 'kindNm', width: '100px' },
                { text: 'QM part', sortable: false, align: 'center',value: 'qmPart', width: '50px' },
                { text: 'Qty', sortable: false, align: 'center',value: 'porQty', width: '50px' },
                { text: 'Result', sortable: false, align: 'center',value: 'resNm', width: '50px' },
                // { text: 'B.O.M', sortable: false, align: 'center',value: 'bomaction', width: '50px' },
                { text: 'Req. Date', sortable: true, align: 'center',value: 'reqDate', width: '150px' },
                { text: 'Insp. Date', sortable: true, align: 'center',value: 'insDate', width: '150px' },
                { text: 'LQC/QM attend', sortable: false, align: 'center',value: 'wlq', width: '150px' },
                { text: 'Witness attend', sortable: false, align: 'center',value: 'wow', width: '150px'},
                { text: 'Maker attend', sortable: false, align: 'center',value: 'wmk', width: '50px'},
              ],
    selectedRowIndex: null, // Lưu index của dòng đang được chọn          
  }),
  components: {
    DxDateBox,
    // AppButton,
  },

  computed: {
  },

  watch: {
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    this.init()
    //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang

    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },
  methods: {
    checkMobile() {
      this.isMobileDevice = window.innerWidth <= 800;
      // console.log('this.isMobileDevice', this.isMobileDevice);
      
    },
    onScroll() {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || document.documentElement.scrollTop || 0;
      
      // Chỉ cập nhật biến fab khi trạng thái thực sự thay đổi
      if (this.fab !== (top > 100)) {
        this.fab = top > 100;
      }
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
  
    btnRetrieve() {
        this.gridMainList = []
        this.getMainList()
    },
    getStrFormat(date) {
      this.stDate = getDateFormat(date)
      return getDateFormat(date)
    },
    init() {
      let toDay = new Date
      toDay.setDate(toDay.getDate() + 0);
      this.stDate = toDay

      this.getList()

    },
    //getList
    async getList() {
      try {
            this.openLoading('searching')
            let params1 = {
              shipNo: '',
            }
            let params2 = {
              deptCd: '',
            }

            await getQMPartList(params1).then(res => {
                  this.qmPartNameList.push('All')
                  res.list.forEach(e => {
                    this.qmPartNameList.push(e.qmPart + ' : ' + e.qmPartNm)
                  });
                  this.qmPartName = this.qmPartNameList[0]
                })
            //getShipList
            await getShipList(params1).then(res => {
                  this.shipNoList.push('All')
                  res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                  });
                  this.shipNo = this.shipNoList[0]
                })
            //getMakerList    
            await getMakerList(params1).then(res => {
                  this.makerCdList.push('All')
                  res.list.forEach(e => {
                    // console.log('######getMakerList===>', e.makerNm)
                    this.makerCdList.push(e.makerCd + ' : ' + e.makerNm)
                  });
                  this.custName = this.makerCdList[0]
                })

          } finally {            
              this.endLoading()
          }

    },
    
    async getMainList() {
        try {
            this.openLoading('searching')
            
            let custName = this.custName
                custName = custName.split(' : ')
                this.makerCd = custName[0]    
            
            let qmPartName = this.qmPartName
                qmPartName = qmPartName.split(' : ')  
                this.qmPart = qmPartName[0] 

            let params = {
                stDate: this.stDate,
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                makerCd: this.makerCd === 'All' ? '' : this.makerCd,
                qmPart: this.qmPart === 'All' ? '' : this.qmPart,
            }
            
            // console.log('######getMainList===>', params)

            await v80b2010List(params).then(res => {
              let list = []
              // console.log('######v80b1010List===>', res)
                res.list.forEach(e => {
                  list.push({
                    rno: e.rno ,
                    shipNo: e.shipNo ,
                    ownNm: e.ownNm ,
                    insDate: e.insDate + '/ '+ e.insTime,
                    reqDate: e.reqDate +'/ '+e.reqTime,
                    custNm: e.custNm,
                    porNo: e.porNo + '-' + e.porSeq,                    
                    itemDesc2: e.itemDesc2,
                    kindNm: e.kindNm,
                    qmPart: e.qmPart,
                    porQty: e.porQty,
                    resNm: (e.resNm === null? 'Not yet result': e.resNm),
                    bomCnt: e.bomCnt,
                    wow: e.wow==='Y'? true:false,
                    wcl: e.wcl==='Y'? true:false,
                    rno: e.rno,
                    wqm: e.wqm==='Y'? true:false,
                    wlq: e.wlq==='Y'? true:false,
                    wmk: e.wmk==='Y'? true:false
                  })
                  
                });

                this.gridMainList = list
                this.listSize = list.length

                if (this.listSize > 0 && this.isMobileDevice == true){
                  this.panel = []
                }
                // console.log('######gridMainList===>', this.gridMainList)
            })

        } finally {
            this.endLoading()
        }
    },

    getColor (calories) {
        if (calories > 400) return 'red'
        else if (calories > 200) return 'orange'
        else return 'green'
    }, 
    
    exportToExcel() {
      if (this.gridMainList.length === 0) {
        alert("No data to export!");
        return;
      }

      try {
        this.openLoading('Exporting Excel...');

        // 1. Định nghĩa tiêu đề cột (Mapping từ key trong data sang tên tiếng Anh/Việt)
        const exportData = this.gridMainList.map(item => ({
          "No": item.rno,
          "Owner": item.ownNm,
          "Ship No": item.shipNo,
          "Supplier": item.custNm,
          "POR No": item.porNo,
          "Item Description": item.itemDesc2,
          "Kind of Insp": item.kindNm,
          "QM Part": item.qmPart,
          "Qty": item.porQty,
          "Result": item.resNm,
          "Req. Date": item.reqDate,
          "Insp. Date": item.insDate,
          "LQC Attend": item.wlq ? 'Y' : 'N',
          "QM Attend": item.wqm ? 'Y' : 'N',
          "Witness OW": item.wow ? 'Y' : 'N',
          "Witness CL": item.wcl ? 'Y' : 'N',
          "Maker Attend": item.wmk ? 'Y' : 'N',
        }));

        // 2. Tạo WorkSheet từ dữ liệu đã map
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // 3. Tạo WorkBook (File Excel)
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Inspection_List");

        // 4. Xuất file với tên định dạng: Inspection_Date.xlsx
        const fileName = `Inspection_List_${new Date().toISOString().slice(0,10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);

      } catch (error) {
        console.error("Export Error:", error);
        alert("Export failed!");
      } finally {
        this.endLoading();
      }
    },

    // Hàm lưu độ rộng vào localStorage
    saveColumnWidths() {
      const widths = {};
      const ths = this.$el.querySelectorAll('.v-data-table th');
      
      ths.forEach((th, index) => {
        // Lưu theo index hoặc value của header để không bị lẫn
        widths[index] = th.style.width;
      });
      
      localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
    },

    // Hàm khôi phục độ rộng khi vào lại trang
    loadColumnWidths() {
      const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
      if (savedWidths) {
        const widths = JSON.parse(savedWidths);
        this.$nextTick(() => {
          const ths = this.$el.querySelectorAll('.v-data-table th');
          ths.forEach((th, index) => {
            if (widths[index]) {
              th.style.width = widths[index];
            }
          });
        });
      }
    },

  },

};
</script>
<style>
@import "~@/assets/css/mobile-table.css";
</style>


